import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useIsCandidatoContratacao } from '@/hooks/useIsCandidatoContratacao';

interface CandidatoRouteProps {
  children: ReactNode;
}

/**
 * Protege rotas exclusivas do candidato (/candidato/*).
 * - Exige autenticação.
 * - Confirma via RPC is_candidato_ativo (fonte única da verdade).
 * - Se não for candidato, redireciona para /intranet.
 */
export function CandidatoRoute({ children }: CandidatoRouteProps) {
  const { user, loading: authLoading } = useAuth();
  const { isCandidato, isLoading } = useIsCandidatoContratacao();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }
    if (!isLoading && !isCandidato) {
      navigate('/intranet', { replace: true });
    }
  }, [user, authLoading, isCandidato, isLoading, navigate]);

  if (authLoading || isLoading || !user || !isCandidato) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary" />
      </div>
    );
  }

  return <>{children}</>;
}
